import { Tooltip } from "antd";
import { AudioOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface VoiceOrderButtonProps {
  onClick: () => void;
  /** Локален режим (docs/edge.md): бутонът стои, но е disabled с подсказка. */
  locked: boolean;
  /** Тесен екран — по-малкият бутон до мини търсачката на релсата. */
  small?: boolean;
}

/**
 * Микрофонът за гласова поръчка (отваря `VoiceOrderModal`, без shortcut) —
 * вдясно от търсачката на списъка с маси и в горната лента в режим „Схема".
 * Родителят го рендира САМО при право open_bill_voice.
 */
export const VoiceOrderButton = ({
  onClick,
  locked,
  small = false,
}: VoiceOrderButtonProps) => {
  const { t } = useTranslation();
  return (
    // Обвивката носи подсказката: disabled бутон не получава mouse
    // събития, затова при заключване той е pointer-events-none.
    <Tooltip title={locked ? t("edge.unavailableOffline") : undefined}>
      <span
        className={`inline-flex shrink-0 ${locked ? "cursor-not-allowed" : ""}`}
      >
        <button
          type="button"
          aria-label="voice order"
          title={locked ? undefined : t("ordering.voiceOrder")}
          onClick={onClick}
          disabled={locked}
          className={`shrink-0 grid place-items-center border border-pos-ctl bg-pos-card text-pos-accent cursor-pointer transition-colors hover:bg-pos-panel disabled:opacity-45 disabled:pointer-events-none ${
            small
              ? "h-8 w-8 rounded-lg text-sm"
              : "h-10 w-10 rounded-xl text-[17px]"
          }`}
        >
          <AudioOutlined />
        </button>
      </span>
    </Tooltip>
  );
};
